export default __webpack_public_path__ + "static/media/discount_accepted.f2798070.svg";